import { Ng2StateDeclaration } from '@uirouter/angular';
import { FiDocumentTemplateEditComponent } from '@fi-app/document-template/document-template-edit/document-template-edit.component';
import { FiDocumentTemplateStatesResolveTemplate } from '@fi-app/document-template/states/resolve/template';
import { FiDocumentTemplateStatesResolvePageTitle } from '@fi-app/document-template/states/resolve/page-title';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiDocumentTemplateEditState: Ng2StateDeclaration = {
    name: FiStateNames.Document.Template.Edit,
    url: '/Edit/:Id',
    views: {
        '@': {
            component: FiDocumentTemplateEditComponent,
        },
    },
    resolve: {
        template: FiDocumentTemplateStatesResolveTemplate,
        pageTitle: FiDocumentTemplateStatesResolvePageTitle,
    },
};
